export default "__VITE_ASSET__C$ULHdFF__"